import { ModalDirective } from 'ng2-bootstrap/components/modal';
import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  ViewChild
} from '@angular/core';
import { TranslateService } from '../../shared/translate/translate.service';
import { AuthService } from '../../shared/models/auth.service';
import { PrePostTripQuestionService } from '../models/pre-post-trip-question.service';
import { IKeyValueInterface, WeGoConfig } from '../../shared/config';
import { ActivatedRoute } from '@angular/router';
import { CustomeTripQuestion, PrepostQuestionsByLang } from '../models/custom-question.model';
import { StringDecoder } from 'string_decoder';

@Component({
  selector: 'wego-update-pre-post-trip-question',
  template: require('../views/pre-post-trip-question-update.component.html'),
  providers: [PrePostTripQuestionService]
})
export class PrePostTripQuestionUpdateComponent implements OnInit {
  errorMessage: any;
  sub: any;
  apiErrorMsg: any;
  errorModel: IKeyValueInterface[];
  module: string;
  isEditMode: any;
  popupMsg: string;
  model: CustomeTripQuestion;
  isLoading: boolean;
  _popupTitle: string;
  originalmodel: CustomeTripQuestion;
  preferredLanguageList: any;
  defaultlanguage: string = 'EN';
  selectedLanguage: string = 'EN';
  QuestionError: string = '';

  @ViewChild('UpdatePrePostTripQuestion')
  public UpdatePrePostTripQuestion: ModalDirective;
  @ViewChild('successPopup') public successPopup: any;
  @Output('OnClose') onClose = new EventEmitter();
  indexNumber: number;
  @Input()
  set popupTitle(popupTitle: string) {
    this._popupTitle = popupTitle && popupTitle.trim();
  }
  get popupTitle() {
    return this._popupTitle;
  }

  constructor(
    private authService: AuthService,
    private translate: TranslateService,
    private prePostTripQuestionService: PrePostTripQuestionService,
    private activeRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.model = new CustomeTripQuestion();

    this.module = this.translate.instant('LblPrePostTripQuestion');
    this.preferredLanguageList = WeGoConfig.PREFERRED_LANGUAGE;

  }

  public hide() {
    this.UpdatePrePostTripQuestion.hide();
  }

  public show(
    questionType: string,
    prePostQuestionHashId: CustomeTripQuestion,
    iitem: number,
    isEditMode: boolean
  ): void {
    this.QuestionError = '';
    this.isEditMode = isEditMode;
    console.log('value of  : ' + prePostQuestionHashId);
    if (questionType == 'PREBEFORE' || questionType == 'PREAFTER') {
      this.popupTitle =
        this.translate.instant('LblCustom') +
        ' ' +
        this.translate.instant('LblPreTripQuestion');
    } else if (questionType == 'FAZ') {
      this.popupTitle =
        this.translate.instant('LblCustom') +
        ' ' +
        this.translate.instant('LblFazTripQuestion');
    } else {
      this.popupTitle =
        this.translate.instant('LblCustom') +
        ' ' +
        this.translate.instant('LblPostTripQuestion');
    }
    this.clearInputs();
    this.indexNumber = iitem;

    if (prePostQuestionHashId) {
      this.model = prePostQuestionHashId;
      this.selectedLanguage = this.model.defaultLanguage;
      this.originalmodel = JSON.parse(JSON.stringify(this.model));
    }
    if (this.model.defaultLanguage) {
      this.selectedLanguage = this.model.defaultLanguage;
    } else {
      this.selectedLanguage = this.defaultlanguage;
    }

    if (questionType == 'FAZ') {
      this.model.answerType = 'TEXT';
      this.model.isRequired = true;
      this.model.defaultLanguage = this.selectedLanguage = this.defaultlanguage = 'EN';
    }

    this.UpdatePrePostTripQuestion.show();
  }

  OnClose() {
    this.model.name = this.originalmodel.name;
    this.model.question = this.originalmodel.question;
    this.model.isRequired = this.originalmodel.isRequired;
    this.model.questionType = this.originalmodel.questionType;
    this.model.answerType = this.originalmodel.answerType;
    this.model.defaultLanguage = this.originalmodel.defaultLanguage;
    this.model.prepostQuestionsByLangList = this.originalmodel.prepostQuestionsByLangList;
    this.hide();
  }

  OnAddTranslation() {
    //Check if translation already exists if there, replace it
    if (!this.model.question) {
      this.QuestionError = this.translate.instant('LblQestionTextRequired')
      return;
    }
    this.QuestionError = '';

    var translation = this.model.prepostQuestionsByLangList.find(x => x.languageCode == this.selectedLanguage);
    if (translation) {
      if (!translation.isDeleted) {
        translation.questionText = this.model.question;
      } else {
        translation.isDeleted = false;
        translation.questionText = this.model.question;
      }
    } else {

      translation = new PrepostQuestionsByLang();
      translation.language = this.selectedLanguage;
      translation.languageCode = this.selectedLanguage;
      translation.questionText = this.model.question;
      translation.isDeleted = false;

      this.model.prepostQuestionsByLangList.push(translation);
    }
  }

  OnLanguageChange() {
    var translation = this.model.prepostQuestionsByLangList.find(x => !x.isDeleted && x.languageCode == this.selectedLanguage);
    if (translation) {
      this.model.question = translation.questionText;
    } else {
      this.model.question = '';
    }
  }

  DeleteQuestionLanguage(item: any) {
    item.isDeleted = true;
    if (item.languageCode == this.selectedLanguage) {
      this.model.question = '';
    }
  }

  GetlanguageQuetionList(): any {
    return this.model.prepostQuestionsByLangList.filter(x => !x.isDeleted);
  }

  OnSubmit(forms: any) {
    if (this.model.questionType == 'FAZ') {
      this.OnAddTranslation();
      console.log('OnAddTranslation called');
    }

    this.isLoading = true;
    this.prePostTripQuestionService
      .CheckCustomTripQuestion(this.model)
      .subscribe(
        res => {
          if (res.data) {
            if (this.model) {
              console.log(this.model);
              this.onClose.emit({
                model: this.model,
                isEditMode: this.isEditMode
              });
              this.hide();
            }
          } else {
            this.errorModel = res.error;
          }
          this.isLoading = false;
        },
        error => {
          this.isLoading = false;
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }

  public clearInputs() {
    this.model = new CustomeTripQuestion();
    this.errorModel = [];
  }

  public GetPrePostQuestionDetailsByHashId(prePostQuestionHashId: string) {
    this.sub = this.activeRoute.params.subscribe(params => {
      this.isEditMode = false;
      //prePostQuestionHashId = params["id"] || "";
      if (prePostQuestionHashId != '') {
        this.isEditMode = true;
        this.prePostTripQuestionService
          .GetPrePostTripQuestionByHashId(prePostQuestionHashId)
          .subscribe(
            res => {
              this.model = res.data;
            },
            error => {
              this.errorMessage = this.authService.HandleErrorStatusCode(error);
            }
          );
      }
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/pre-post-trip-question/components/pre-post-trip-question-update.component.ts